import { cloneElement, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useMenuStore } from "../zustand/store/useMenuStore";
import useQueryLinkNavigate from "../hooks/useQueryLinkNavigate";
import Pages from "../common/Pages"
import PopupPages from "../common/PopupPages"
import Navbar from '../sidebar/Navbar';
import MemberPages from "../common/MemberPages";
import SessionCheck from "../common/SessionCheck";
import AuthGuard from "../common/AuthGuard";

const Router = () => {

    const { pathname, basePath } = useQueryLinkNavigate();
    const mainTitle = useMenuStore(state => state.currentInfo.mainTitle);
    
    useEffect(()=> {
        
        // 현재 경로에 맞는 타이틀 찾기
        const title = '응급진료정보';
        const subTitle = Pages.find(p => p.path === pathname )?.titlename;
        const subTitle2 = PopupPages.find(p => p.path === pathname )?.titlename;
        const subTitle3 = MemberPages.find(p => p.path === pathname )?.titlename;
        const subTitle4 = mainTitle;

        // 우선순위대로 존재하는 첫 번째 titlename 선택
        const pageTitle = subTitle || subTitle2 || subTitle3 || subTitle4;

        // 최종 제목 설정
        document.title = pageTitle ? `${title} - ${pageTitle}` : title;
    })

    return (
        <Routes>
            { MemberPages.map((p, index) => <Route key={index} path={p.path} element={p.comp} /> ) }
            <Route element={<SessionCheck/>}>
                <Route element={<Navbar/>}>
                    { Pages.map((p, index) => <Route key={index} path={p.path} element={<AuthGuard>{cloneElement(p.comp, { key: basePath })}</AuthGuard>} /> ) }
                </Route>
                { PopupPages.map((p, index) => <Route key={index} path={p.path} element={p.comp} /> ) }
            </Route>
        </Routes>
    );
};

export default Router;
